/**
 * "Acme Store (hello@acme.com)", or whichever half exists. Returns undefined when
 * there is no sender at all — e.g. it was deleted after the email was set up — so
 * the caller can drop the row instead of rendering a blank one.
 *
 * Intentionally duplicated from the apps/email copy of this component: the two
 * live in packages on different React and MUI majors, so there is no shared
 * package both can import from yet. Keep the two implementations identical.
 */
export function buildSenderLine(
  name?: string,
  email?: string
): string | undefined {
  const trimmedName = name?.trim();
  const trimmedEmail = email?.trim();

  if (trimmedName && trimmedEmail) {
    return `${trimmedName} (${trimmedEmail})`;
  }
  return trimmedName || trimmedEmail || undefined;
}
